export default __webpack_public_path__ + "static/media/upload-camera.b6513092.svg";